// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { InstrumentConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/Instrument';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useBridgeInstrumentConfiguration: () => UseQueryResult<
  TemplateContract<InstrumentConfiguration> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { bridgeOperator, crossChainRepresentative } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: [
      'queryBridgeInstrumentConfiguration',
      offset,
      ledgerApi,
      bridgeOperator,
      crossChainRepresentative,
    ],
    queryFn: async () => {
      return ledgerApi.queryBridgeInstrumentConfiguration(
        offset!,
        bridgeOperator,
        crossChainRepresentative,
      );
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeInstrumentConfiguration;
